export default "__VITE_ASSET__CZzvPyBF__"